import { IElementRectProps, IWindowData } from '@bg-shared/integrations/shared/interfaces';

export const isInViewport = (elementRect: IElementRectProps, windowData: IWindowData): boolean => {
    const top = elementRect.top + windowData.clientRect.top + windowData.scrollY;
    const left = elementRect.left + windowData.clientRect.left + windowData.scrollX;

    return (
        top + elementRect.height < windowData.scrollY + windowData.height &&
        left + elementRect.width > windowData.scrollX
    );
};
